export default __webpack_public_path__ + "imgs/562921df5c24e3e82fe14f32f74b8fd5.png";